import {
  Button,
  Card,
  Col,
  Flex,
  Row,
  Switch,
  Typography,
  message,
} from "antd";
import React from "react";
import HierarchyIcon from "../../../../../../Theme/CustomIcons/Icons/CustomIcons/HierarchyIcon";
import PeopleIcon from "../../../../../../Theme/CustomIcons/Icons/Users/PeopleIcon";
import FlagIcon from "../../../../../../Theme/CustomIcons/Icons/Essetional/FlagIcon";
import CalendarTickIcon from "../../../../../../Theme/CustomIcons/Icons/Users/CalendarTickIcon";
import { useSelector, useDispatch } from "react-redux";
import ArrowCircleRight2Icon from "../../../../../../Theme/CustomIcons/Icons/Arrow/ArrowCircleRight2Icon";
import MessageTextIcon from "../../../../../../Theme/CustomIcons/Icons/Emails,Messages/MessageTextIcon";
import { updateEntityStatusAction } from "../../../../../../store/action/admin/dimensionsEntityActions";
import { getAllEntityListAction } from "../../../../../../store/action/admin/entityActions";

const { Text } = Typography;

const CompanyCards = ({ onOpenComments, onViewDetails }) => {
  const dispatch = useDispatch();
  const themeDefault = useSelector((state) => state.themeDefault);
  const allEntityState = useSelector((state) => state.getAllEntityList);
  const isLightBg = themeDefault?.info?.themeColor === "default";

  const entities = allEntityState?.info || [];

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    try {
      return new Date(dateString).toLocaleDateString();
    } catch {
      return "-";
    }
  };

  const handleStatusChange = async (entity, checked) => {
    if (!entity?._id && !entity?.entityId) return;

    const entityId = entity._id || entity.entityId;
    const nextStatus = checked ? "Active" : "Archived";

    try {
      await dispatch(
        updateEntityStatusAction(entityId, { status: nextStatus })
      );
      message.success(`Entity status updated to ${nextStatus} successfully`);

      // Refresh the entity list after status change
      await dispatch(getAllEntityListAction());
    } catch (err) {
      console.error("Failed to update entity status:", err);
      message.error(err?.message || "Failed to update entity status");
    }
  };

  return (
    <>
      <Row gutter={[16, 16]}>
        {entities.map((entity, index) => (
          <Col span={12} key={entity._id || index}>
            <Card
              style={{
                padding: "16px 16px 4px 16px",
              }}
              title={
                <Flex
                  align="center"
                  justify="space-between"
                  style={{
                    borderBottom: themeDefault?.info?.newConfig?.cardborder,
                    width: "100%",
                    paddingBottom: 8,
                  }}
                >
                  {entity.name || "-"}

                  <Switch
                    checked={entity.status === "Active"}
                    onChange={(checked) => handleStatusChange(entity, checked)}
                  />
                </Flex>
              }
            >
              <Flex align="center" justify="space-between">
                <Flex vertical gap={8}>
                  <Text>
                    <HierarchyIcon size="small" />{" "}
                    {entity.stats.totalDimensions || "-"} Dimensions
                  </Text>
                  <Text>
                    <FlagIcon size="small" /> {entity.country || "-"}
                  </Text>
                </Flex>
                <Flex vertical gap={8}>
                  <Text>
                    <PeopleIcon size="small" /> {entity.stats.totalUsers || "-"}{" "}
                    Users
                  </Text>
                  <Text>
                    <CalendarTickIcon size="small" /> Created on{" "}
                    {formatDate(entity.createdAt)}
                  </Text>
                </Flex>
              </Flex>
              <Flex
                align="center"
                justify="space-between"
                style={{
                  width: "100%",
                  marginTop: 8,
                  borderTop: themeDefault?.info?.newConfig?.cardborder,
                }}
              >
                <Button
                  type="link"
                  size="small"
                  onClick={() =>
                    onOpenComments &&
                    onOpenComments(entity._id || entity.entityId)
                  }
                  style={{
                    color: isLightBg ? "#000000" : "#ffffff",
                    width: "50%",
                    border: "none",
                    fontSize: 12,
                  }}
                >
                  <MessageTextIcon size="small" />
                  Comments
                </Button>

                {/* separator line */}
                <span
                  style={{
                    display: "inline-block",
                    width: "1px",
                    height: "20px",
                    backgroundColor: isLightBg ? "#ccc" : "#666",
                    margin: "0 4px",
                  }}
                />

                <Button
                  type="link"
                  size="small"
                  onClick={() =>
                    onViewDetails &&
                    onViewDetails(entity._id || entity.entityId)
                  }
                  style={{
                    border: "none",
                    color: isLightBg ? "#000000" : "#ffffff",
                    width: "50%",
                    fontSize: 12,
                  }}
                >
                  <ArrowCircleRight2Icon size="small" />
                  Details
                </Button>
              </Flex>
            </Card>
          </Col>
        ))}
      </Row>
    </>
  );
};

export default CompanyCards;
